(function () {
  function slideUp(el, duration) {
    el.style.overflow = 'hidden';
    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height = el.offsetHeight + 'px';
    requestAnimationFrame(function () { el.style.height = '0px'; });
    setTimeout(function () {
      el.style.display = 'none'; el.style.height = ''; el.style.transition = ''; el.style.overflow = '';
    }, duration);
  }

  function slideDown(el, duration) {
    el.style.display = 'block';
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    el.style.transition = 'height ' + duration + 'ms ease';
    var h = el.scrollHeight;
    requestAnimationFrame(function () { el.style.height = h + 'px'; });
    setTimeout(function () {
      el.style.height = ''; el.style.transition = ''; el.style.overflow = '';
    }, duration);
  }

  function initProductAccordion() {
    document.querySelectorAll('.about__accordion-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var siblings = [];
        var parent = toggle.parentElement;
        if (parent) {
          var all = parent.querySelectorAll('.about__accordion-description');
          all.forEach(function (desc) { siblings.push(desc); });
        }
        var idx = Array.from(toggle.parentElement.children).indexOf(toggle);

        if (!toggle.classList.contains('active')) {
          toggle.classList.add('active');
          siblings.forEach(function (sib, i) {
            if (i === Math.floor(idx / 2)) slideDown(sib, 300);
            else slideUp(sib, 300);
          });
        } else {
          toggle.classList.remove('active');
          siblings.forEach(function (sib) { slideUp(sib, 300); });
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', function () { initProductAccordion(); });
  initProductAccordion();
})();
